const FSendApi = { url: "https://fsend.cn", ws: "wss://fsend.cn/ws/" };

const FSendApi_PRODUCTION = {
  url: `${window.location.protocol}//${window.location.hostname}:${window.location.port}`,
  ws: `${window.location.protocol === "https:" ? "wss" : "ws"}:${window.location.hostname}/ws/`,
};
console.log("protocal:" + window.location.protocol);
console.log("location: " + window.location.hostname);
console.log("ENV:" + process.env.REACT_APP_ENV);

export default process.env.REACT_APP_ENV === "DEV" ? FSendApi : FSendApi_PRODUCTION;
